import { useEffect, useState } from "react";
import { useDispatch, useStore } from "react-redux";

import "./Auftraege.css";
import AuftraegeForm from "./AuftraegeForm";
import AuftraegeTabelle from "./AuftraegeTabelle";
import { currenciesActions, metalsActions } from "../actions";
import { BeendenButton } from "../utils/components";
import CONFIG from "../config";
import { Alert } from "react-bootstrap";

const Auftraege = (props) => {
  const { configStorage } = useStore().getState();
  const dispatch = useDispatch();
  const baseRequest = configStorage.getRequestData("basedata");
  baseRequest.restRoot = configStorage.getRestRoot();
  delete baseRequest.url;
  const [loaded, setLoaded] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // load required data only once
    if (!loaded) {
      setLoaded(
        Promise.all([
          dispatch(metalsActions.fetchBaseData(baseRequest)),
          dispatch(metalsActions.fetchListData(baseRequest)),
          dispatch(currenciesActions.fetchBaseData(baseRequest)),
          dispatch(currenciesActions.fetchListData(baseRequest))
        ]).catch(e => {
          console.error(e);
          setMessage(e.message+ " Die Suche nach Namen ist nur eingeschränkt möglich.");
        })
      );
    }
  }, [baseRequest, dispatch, loaded]);

  const today = new Date().toISOString().substring(0, 10);

  const queryParams = {
    auftragsNummer: {
      label: "Auftragsnummer",
      type: "number"
    },
    kennziffer: {
      label: "Kennziffer/Produktbezeichnung",
      type: "number",
      ariaLabel: "Suche nach der Kennziffer oder Produktbezeichnung",
      placeholder: "Suche nach Produkt"
    },
    auftragsStatus: {
      label: "Auftragsstatus"
    },
    geschaeftsart: {
      label: "Geschäftsart"
    },
    kundenkonto: {
      label: "Kontonummer des Kunden",
       db_not: true
    },
    erfasserFiliale: {
      label: "Erfasser Filiale",
      db_only: true,
      erfasser_select: true
    },    
    iban: {
      label: "IBAN des Kunden"
    },
    lieferFiliale: {
      label: "Empfänger Filiale",
      liefer_select: true
    },
    ablieferFiliale: {
      label: "Abliefer Filiale",
      abliefer_select: true
    },
    datumVon: {
      label: "Datum-von",
      type: "date",
      default: today
    },
    datumBis: {
      label: "Datum-bis",
      type: "date",
    },
    euroVon: {
      label: "Euro-Gegenwert-von",
      type: "number"
    },
    euroBis: {
      label: "Euro-Gegenwert-bis",
      type: "number"
    },
    personenNummer: {
      label: "Personennummer"
    },
  };
  if (CONFIG.Admin.hostApi.includes("SO279")) {
    delete queryParams.iso;
    delete queryParams.text;
    delete queryParams.euroVon;
    delete queryParams.euroBis;
  }

  const initialValues = Object.keys(queryParams).filter(key => !!queryParams[key].default)
    .reduce((prev, key) => {
      prev[key] = queryParams[key].default;
      return { ...prev };
    }, {});


  return <div>
    <h1>Auftragsübersicht</h1>
    {message
      ? <Alert className="p-1">{message}</Alert>
      : null
    }
    <AuftraegeForm initialValues={initialValues} queryParams={queryParams}></AuftraegeForm>
    <AuftraegeTabelle queryParams={queryParams}></AuftraegeTabelle>
    {configStorage.isVerseNeo()
      ? <>
        <a
          href={configStorage.getBackToLandingPageLink()}
          className="btn btn-info col-12 col-md-3 col-lg-2"
        >
          Zurück zur Startseite
        </a>
        <BeendenButton className="col-12 col-md-3 col-lg-2" />
      </>
      : null
    }
  </div>;
};
export default Auftraege;
